<template>
  <div class="relative w-full mx-auto px-4 md:px-8 gap-8 flex flex-col">
    <!-- Progress Bar -->
    <OnboardingProgressBar
      :current-step="currentStep"
      :total-steps="totalSteps"
    />

    <!-- Step Content -->
    <div
      class="w-full max-w-6xl mx-auto"
      :class="{ 'pointer-events-none': isLoading }"
    >
      <!-- Step 1: English Level Selection -->
      <div v-if="currentStep === 1" class="animate-fade-in">
        <OnboardingLevelStep
          :selected-level="quizData.level"
          @level-selected="handleLevelSelected"
        />
      </div>

      <!-- Step 2: Reason for Visit -->
      <div v-if="currentStep === 2" class="animate-fade-in">
        <OnboardingReasonStep
          :selected-reason="quizData.reason"
          @reason-selected="handleReasonSelected"
        />
      </div>
    </div>

    <!-- Navigation Buttons -->
    <div class="w-full max-w-4xl mx-auto mt-8 flex justify-between">
      <!-- Previous Button -->
      <BaseButton
        v-if="currentStep > 1"
        color="secondary"
        class="px-8 py-3 text-lg font-semibold"
        @click="goToPreviousStep"
      >
        <div class="flex items-center gap-2">
          <BaseIcon icon="arrow-left" class="text-lg" />
          <span>Previous</span>
        </div>
      </BaseButton>

      <!-- Spacer for layout when no previous button -->
      <div v-else></div>

      <!-- Next/Submit Button -->
      <BaseButton
        v-if="currentStep < totalSteps && canProceedToNext"
        color="primary-gradient"
        class="px-8 py-3 text-lg font-semibold shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all duration-300"
        @click="goToNextStep"
      >
        <div class="flex items-center gap-2">
          <span>Next</span>
          <BaseIcon icon="arrow-right" class="text-lg" />
        </div>
      </BaseButton>

      <!-- Submit Button (Final Step) -->
      <!-- <BaseButton
        v-else
        color="primary-gradient"
        class="px-8 py-3 text-lg font-semibold shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all duration-300"
        :is-loading="isLoading"
        :disabled="!isSubmitButtonDisabled"
        @click="handleSubmit"
      >
        <div class="flex items-center gap-2">
          <BaseIcon icon="rocket-lunch" class="text-lg" />
          <span>Choose Plan & Start Learning</span>
        </div>
      </BaseButton> -->
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/Base/BaseButton.vue'
import BaseIcon from '@/components/Base/BaseIcon.vue'
import OnboardingLevelStep from '@/components/Onboarding/OnboardingLevelStep.vue'
import OnboardingReasonStep from '@/components/Onboarding/OnboardingReasonStep.vue'
import OnboardingProgressBar from '@/components/Onboarding/OnboardingProgressBar.vue'

export default {
  name: 'OnboardingQuiz',

  components: {
    BaseButton,
    BaseIcon,
    OnboardingLevelStep,
    OnboardingReasonStep,
    OnboardingProgressBar
  },

  props: {
    isLoading: { type: Boolean, default: false }
  },

  data() {
    return {
      currentStep: 1,
      totalSteps: 2,
      quizData: {
        level: null,
        reason: null
      }
    }
  },

  computed: {
    canProceedToNext() {
      switch (this.currentStep) {
        case 1:
          return this.quizData.level !== null
        case 2:
          return this.quizData.reason !== null
        default:
          return false
      }
    }
  },

  methods: {
    handleLevelSelected(level) {
      this.quizData.level = level
      // Auto-advance to next step after selection
      this.$nextTick(() => {
        this.goToNextStep()
      })
    },

    handleReasonSelected(reason) {
      this.quizData.reason = reason
      // Emit quiz completion event after selecting reason (last step)
      this.$nextTick(() => {
        this.$emit('quiz-completed', this.quizData)
      })
    },

    goToNextStep() {
      if (this.currentStep < this.totalSteps) {
        this.currentStep++
      }
    },

    goToPreviousStep() {
      if (this.currentStep > 1) {
        this.currentStep--
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.animate-fade-in {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
